import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { isWelcomeRoute } from "../../../onboarding/first-install-redirect";
import { isRoleStepRequired } from "../../../welcome/welcome-flow";
import { isWmsRoute } from "../../wms-route";

export interface JobLevelBackfillUser {
  email: string;
  jobProfile?: { job?: readonly string[] | null; level?: string | null };
}

export function shouldShowJobLevelBackfillPrompt(args: {
  firstInstallOnboardingPending?: boolean;
  isAdminImpersonation?: boolean;
  user: JobLevelBackfillUser | null | undefined;
  pathname: string;
}): boolean {
  const {
    firstInstallOnboardingPending,
    isAdminImpersonation,
    user,
    pathname,
  } = args;
  if (
    !user ||
    firstInstallOnboardingPending ||
    isWelcomeRoute(pathname) ||
    isWmsRoute(pathname)
  ) {
    return false;
  }
  if (isAdminImpersonation || isRedoEmailAddress(user.email)) {
    return false;
  }
  return isRoleStepRequired(user.jobProfile);
}
